import React, { Component } from "react";
import DocumentTitle from "react-document-title";
// import ProgressBar from "../Spinner/ProgressBar";
import Header from "./Header/Header";
import Menu from "./Menu";
import MenuLogged from "./MenuLogged";
// import Header from "../Header";
import { connect } from "react-redux";
import {
  changeStatusSocket,
  disconnectSocket,
} from "../../redux/actions/socket.action";
// import Footer from '../Footer'
import { message } from "antd";
// import { ToastContainer } from "react-toastify";
import { LocalStore } from "../../utils/LocalStore";
import MapLayer from "../../containers/TTQH/MapPopup/MapLayer";
import MapLayerQHCT from "../../containers/TTQH/MapPopup/MapLayerQHCT";

const PERCENT_COMPLETE = 100;
class MainLayout extends Component {
  static defaultProps = {
    isLoadingPopup: false,
    isFocusSubmit: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      minified: false,
      percent: -1,
      autoIncrement: false,
      intervalTime: 200,

      isLogin: false,
      isShowMapLayer: false
    };
  }

  // scroll top khi bắt đầu load trang
  componentDidMount() {
    window.scrollTo(0, 0);
    this.setState({
      isLogin: this.isLogged(),
    });
    this.configMessage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showProgressBar !== this.props.showProgressBar) {
      // hiển thị progress bar
      if (this.props.showProgressBar === true) {
        this.startWithAutoIncrement();
      } else {
        // this.stopWithAutoIncrement();
        this.setPercent(PERCENT_COMPLETE);
      }
    }

    if (this.props.isSocket) {
      if (this.props.history) {
        message.info("Tài khoản đã bị thay đổi");
        setTimeout(() => {
          LocalStore.getInstance().save("loginSession", null);
          LocalStore.getInstance().save("loginRole", null);
          this.props.history.push("/dang-nhap");
          this.props.changeStatusSocket(false);
          this.props.disconnectSocket(true);
        }, 3000);
      }
    }

    if (prevProps.isShowMapLayer !== this.props.isShowMapLayer) {
      console.log('this.props.isShowMapLayer', this.props.isShowMapLayer);
      this.setState({
        isShowMapLayer: this.props.isShowMapLayer,
      });
    }
  }

  // shouldComponentUpdate(nextProps, nextState){
  //   return nextProps.isShowMapLayer !== this.props.isShowMapLayer; // equals() is your implementation
  // }

  isLogged = () => {
    let token = LocalStore.getInstance().read("loginSession");
    if (token) return true;
    return false;
  };

  /**
   * hiển thị progressbar
   **/
  startWithAutoIncrement = () => {
    this.setState({
      percent: 0,
      autoIncrement: true,
      intervalTime: Math.random() * 150,
    });
  };

  /**
   * Dừng progressbar
   **/
  stopWithAutoIncrement = () => {
    setTimeout(() => {
      this.setState({
        percent: -1,
        autoIncrement: false,
        intervalTime: 150,
      });
    }, 500);
  };

  setPercent = (percent) => {
    this.setState(
      {
        percent: percent,
      },
      () => {
        if (percent === PERCENT_COMPLETE) {
          this.stopWithAutoIncrement();
        }
      }
    );
  };

  configMessage() {
    message.destroy();
    message.config({
      getContainer: () => document.getElementById("main-header"),
    });
  }

  render() {
    const { title, className, children } = this.props;
    // const { percent, autoIncrement, intervalTime } = this.state;

    return (
      <DocumentTitle title={`${title ? title + " | " : ""} TTQH TP.ĐàNẵng`}>
        <div id="mainlayout">
          <Header {...this.props} />

          <div style={{ display: "flex" }}>
            {this.state.isLogin ? <MenuLogged {...this.props} /> : <Menu {...this.props} />}
            {this.props.isShowMapLayer ? (
              <div style={{ display: "flex" }}>
                <div className="col-left-10-white"></div>
                {this.isLogged() ? (
                  <MapLayer></MapLayer>
                ) : 
                  // <MapLayerQHCT></MapLayerQHCT>
                  null
                }
              </div>
            ) : null}

            <div style={{ width: "100%" }}>
              {/* <ProgressBar
                percent={percent}
                autoIncrement={autoIncrement}
                intervalTime={intervalTime}
                spinner={false}
              /> */}
              <div className={`content pdt60 ${className} minheight100`}>
                <div>{children}</div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    isSocket: state.socket.isSocket,
    isShowMapLayer: state.menu.isShowMapLayer,
  };
};

const mapDispatchToProps = {
  changeStatusSocket: changeStatusSocket,
  disconnectSocket: disconnectSocket,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
